import { GRAY_0, GRAY_8 } from './mc-tokens';

export const MODUS_USER_INFO_STYLESHEET = `
  .tc-user-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .tc-user-info-avatar-wrapper {
    flex-shrink: 0;
    cursor: default;
  }

  .tc-user-info-avatar-wrapper--clickable {
    cursor: pointer;
  }

  .tc-user-info-text {
    text-align: center;
    width: 100%;
    margin-top: 4px;
  }

  .tc-user-info-truncated {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  .tc-user-info-email {
    color: ${GRAY_8};
  }

  .modus-wc-avatar {
    background-color: ${GRAY_0};
    border-radius: 50%;
  }
`;
